// @ts-ignore
import React, { ReactElement, useEffect, useState } from 'react';

let hydrating = true;

export function useHydrated() {
	const [hydrated, setHydrated] = useState(() => !hydrating);

	useEffect(function hydrate() {
		hydrating = false;
		console.debug('hydrating:', hydrating);
		setHydrated(true);
	}, []);

	return hydrated;
}

/**
 * ClientOnly component to render children only after JS has been hydrated
 */
export const ClientOnly = ({ children }: { children: ReactElement }) => {
	return useHydrated() ? <>{children}</> : null;
};
